const switchItems = [
  {
    label: 'Forms',
    value: 'forms'
  },
  {
    label: 'Patient Communication',
    value: 'patient-communication'
  },
  {
    label: 'Clinical Notes',
    value: 'clinical-notes'
  },
  {
    label: 'Check-in Steps',
    value: 'check-in-steps'
  },
  {
    label: 'Self Scheduling Steps',
    value: 'self-scheduling-steps'
  }
];

export default switchItems;
